import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The product's single most identity-carrying control (design spec §3.5).
 *
 * The press is a real 3px translate onto a collapsing ink plate — LOCKED, and
 * deliberately kept in CSS (`:active`) rather than React state so it survives a
 * re-render mid-press and costs nothing.
 */
export function Button({ variant = "primary", size = "md", fullWidth = false, loading = false, loadingLabel, className, disabled, type = "button", children, ...rest }) {
    const classes = [
        "wr-btn",
        `wr-btn--${variant}`,
        `wr-btn--${size}`,
        fullWidth ? "wr-btn--full" : "",
        className ?? "",
    ]
        .filter(Boolean)
        .join(" ");
    return (_jsx("button", { type: type, className: classes, disabled: disabled === true || loading, "aria-busy": loading || undefined, ...rest, children: loading ? (_jsxs(_Fragment, { children: [_jsx("span", { className: "wr-spinner" }), _jsx("span", { children: loadingLabel ?? children })] })) : (children) }));
}
/**
 * 34px visual, 44px hit area — §15.1's rule applied literally: the transparent
 * padding is the touch target and the tinted square is what you see.
 */
export function IconButton({ label, round = false, large = false, className, children, ...rest }) {
    const classes = [
        "wr-icon-btn",
        round ? "wr-icon-btn--round" : "",
        large ? "wr-icon-btn--40" : "",
        className ?? "",
    ]
        .filter(Boolean)
        .join(" ");
    return (_jsx("button", { type: "button", className: classes, "aria-label": label, title: label, ...rest, children: _jsx("span", { className: "wr-icon-btn__visual", children: children }) }));
}
export function Spinner({ className }) {
    return _jsx("span", { className: ["wr-spinner", className ?? ""].filter(Boolean).join(" ") });
}
//# sourceMappingURL=Button.js.map